import Command from '@ckeditor/ckeditor5-core/src/command';

export default class RenumberCitationsCommand extends Command {
  execute() {
    const editor = this.editor;
    const range = editor.model.createRangeIn(editor.model.document.getRoot());
    const foundItems = [];
    const childCitationRefs = [];

    for (const item of range.getItems({ ignoreElementEnd: true })) {
      if (item.getAttribute('data-citationcount') && !item.getAttribute('data-parentcitation')) {
        foundItems.push(item);
      }
    }

    for (const item of range.getItems({ ignoreElementEnd: true })) {
      if (item.getAttribute('data-citationcount') && item.getAttribute('data-parentcitation')) {
        childCitationRefs.push(item);
      }
    }

    editor.model.enqueueChange({ isUndoable: false }, writer => {
      for (let i = 0; i < foundItems.length; i++) {
        writer.removeAttribute('data-citationcount', foundItems[i])
        writer.setAttribute('data-citationcount', i + 1, foundItems[i]);
        writer.setAttribute('contenteditable', 'false', foundItems[i]);
        const idOfCitationRef = foundItems[i].getAttribute('id');
        const aboutAttributeOfRef = foundItems[i].getAttribute('about');
        const [baseHref, citationId] = aboutAttributeOfRef.split('#')
        if (!aboutAttributeOfRef.includes(idOfCitationRef) && citationId !== idOfCitationRef) {
          const newAboutAttr = `${baseHref}#${idOfCitationRef}`;
          writer.setAttribute('about', newAboutAttr, foundItems[i])
        }
      }

      for (let i = 0; i < childCitationRefs.length; i++) {
        const parentCitationRefId = childCitationRefs[i].getAttribute('data-parentcitation');
        const foundItemsArr = Array.from(foundItems);
        const citationcount = foundItemsArr.find(ele => {
          if (ele.getAttribute('id') === parentCitationRefId) {
            return ele.getAttribute('data-citationcount');
          }
        });

        if (citationcount && citationcount.getAttribute('data-citationcount')) {
          const parentCitationCount = citationcount.getAttribute('data-citationcount');
          writer.removeAttribute('data-citationcount', childCitationRefs[i])
          writer.setAttribute('data-citationcount', parentCitationCount, childCitationRefs[i]);
          const idOfCitationRef = childCitationRefs[i].getAttribute('id');
          const aboutAttributeOfRef = childCitationRefs[i].getAttribute('about');
          const [baseHref, citationId] = aboutAttributeOfRef.split('#')
          if (!aboutAttributeOfRef.includes(idOfCitationRef) && citationId !== idOfCitationRef) {
            const newAboutAttr = `${baseHref}#${idOfCitationRef}`;
            writer.setAttribute('about', newAboutAttr, childCitationRefs[i])
          }
          writer.setAttribute('contenteditable', 'false', childCitationRefs[i]);
        }
      }
      const idsOfFirstCitedRefs = foundItems.map(item => item?.getAttribute('id'));
      this.editor.fire('reorderedfinalreferences', { idsOfFirstCitedRefs });
    });

    this.refresh();
  }
  refresh() {
    this.isEnabled = true;
  }
}
